import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'reactstrap';

import CartProduct from '../../../models/cart/CartProduct';
import ProductImageModel from '../../../models/ProductImage';
import { modelOf } from '../../../prop-types';
import AnalyticsService from '../../../services/AnalyticsService';
import CartStore from '../../../store/CartStore';
import Icon from '../../common/Icon';
import Price from '../../product/Price';
import ProductImage from '../../product/ProductImage';
import ProductClass from '../../../types/ProductClass';

const CartProductRow = ({ cartStore, analyticsService, product, withTax }) => {
  const removeProduct = () => {
    const params = {
      id: product.id,
    };

    if (product.bundle_id) {
      params.bundleId = product.bundle_id;
    }

    cartStore.remove(params).then(sendRemoveCartAnalyticsEvent);
  };

  const sendRemoveCartAnalyticsEvent = () => {
    analyticsService.removeFromCartStore();
  };

  const createProductImage = (url) => {
    return url
      ? ProductImageModel.create({
          id: 0,
          product_id: '',
          sizes: {
            small: url,
          },
        })
      : null;
  };

  return (
    <Row
      className={classNames('CartProductRow', 'CartModal__product-list--item')}
    >
      <Col
        className="CartModal__left-column-left d-flex align-content-center"
        xs={4}
      >
        <div className="CartModal__column-image d-flex align-content-center">
          <ProductImage
            product={product}
            productImage={createProductImage(product.image_url)}
            size="small"
            forceAspectRatio={false}
            lazyLoading={false}
          />
        </div>
      </Col>
      <Col xs={8}>
        <div className="CartModal__column-info">
          <div className="CartModal__column-row">
            <span className="CartModal__column-quantity">
              {product.ordered_quantity} {product.stock_unit}
            </span>
            <Button
              className="CartModal__remove-button"
              outline
              color="danger"
              onClick={removeProduct}
              disabled={cartStore.cartButtonDisabled}
            >
              <Icon name="trash" />
            </Button>
          </div>
          <div className="CartModal__column-name">
            <span>{product.name}</span>
            {cartStore.cart.show_product_code && (
              <span>{product.productCode}</span>
            )}
          </div>
          {product.variations.length > 0 && (
            <div
              className={classNames('CartModal__column-variations', {
                'CartModal__column-variations--structure-indent':
                  product.class === ProductClass.STRUCTURE,
              })}
            >
              {product.variations.map((variation, index) => (
                <span
                  key={`${variation}-${index}`}
                  className="CartModal__column-variation"
                >
                  {variation}
                </span>
              ))}
            </div>
          )}
          {product.hasPrice && (
            <div className="CartModal__column-price">
              <Price price={product.getPrice(withTax)} />
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

CartProductRow.propTypes = {
  cartStore: modelOf(CartStore).isRequired,
  product: modelOf(CartProduct).isRequired,
  analyticsService: PropTypes.instanceOf(AnalyticsService).isRequired,
};

export default inject(
  'cartStore',
  'analyticsService'
)(observer(CartProductRow));
